import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

import { TabBarComponent } from './tab-bar.component';

@NgModule({
  declarations: [TabBarComponent],
  exports: [TabBarComponent],
  imports: [CommonModule, MatTabsModule, MatIconModule],
})
export class TabBarModule {}
